import {Fragment, PropsWithChildren, ReactElement} from "react"
import {Button} from "antd"
import classNames from "classnames"
import {useStore} from "@ui/stores"
import SwipePanel, {SwipePanelHeight} from "@ui/components/services/common/SwipePanel"
import CloseIcon from "@ui/icons/common/Close"
import LeftIcon from "@ui/icons/common/Left"

type TPanelProps = {
  className?: string
  title: string
  onBack: () => void
  onClose: () => void
} & PropsWithChildren

const Panel = ({className, title, onClose, onBack, children}: TPanelProps): ReactElement => {
  const {settings} = useStore()

  return settings.isMobile ? (
    <div className={classNames("profile-panel", className)}>
      <div className="header">
        <div className="title">{title}</div>
        <Button
          className="button-close"
          shape="circle"
          icon={<CloseIcon/>}
          onClick={onBack}
        />
      </div>
      {children}
    </div>
  ) : (
    <SwipePanel
      onSwipe={onClose}
      header={
        <Fragment>
          <Button className="button-back" icon={<LeftIcon/>} onClick={onBack}/>
          <div className="title">
            {title}
          </div>
        </Fragment>
      }
      height={SwipePanelHeight.FULL}
    >
      <div className={classNames("profile-panel", className)}>
        {children}
      </div>
    </SwipePanel>
)
}

export default Panel
